import { Card, Col, Row } from 'antd';
import { UseRentStatisticsResult } from './useRentStatistics';
import { useDonutGraphOptions } from '../../assets/inventory/dashboard/assets-per-state-options';
import Chart from 'react-apexcharts';
import { FC } from 'react';

const TopRentedEquipmentsCard: FC<{
  statistics: UseRentStatisticsResult['top5Equipments'];
}> = ({ statistics }) => {
  const data = statistics.map((entry) => entry.value);

  const chartOptions = useDonutGraphOptions(
    statistics.map((entry) => entry.description),
    data,
  );

  return (
    <Card className='hp-border-color-black-40 hp-card-6'>
      <Row>
        <Col span={24}>
          <h5 className='hp-mb-32'>Top 5 equipamentos</h5>
        </Col>

        <Col span={24}>
          <div id='earnings-donut-card' className='hp-donut-chart'>
            <Chart
              options={chartOptions}
              series={data}
              type='donut'
              height={700}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default TopRentedEquipmentsCard;
